import React from 'react';
import {render} from 'react-dom';
import {FooterSection} from 'components/LandingPage';
import HotelsHero from './HotelsHero';
import HotelsSeo from './HotelsSeo';
import HotelsDeals from './HotelsDeals';
import HotelsSearchMask from './HotelsSearchMask';
import hotelStore from './store';
import {market, brandLocale} from 'helpers/stableValues';
import {translations} from './translations';

const {searcMask, seo, deals} = hotelStore({market, brandLocale, translations});

render((
  <div>
    <HotelsHero {...searcMask}>
      <HotelsSearchMask {...searcMask}/>
    </HotelsHero>
    <HotelsDeals {...deals}/>
    <HotelsSeo {...seo}/>
    <FooterSection/>
  </div>
), document.getElementById('hotelsLanding'));
